<template>
<div class="ibox ">
    <div class="ibox-title">
        <h5>Agentes conectados</h5>
        <div class="ibox-tools">
            <a class="collapse-link">
                <i class="fa fa-chevron-up"></i>
            </a>
        </div>
    </div>
    <div class="ibox-content table-responsive">
        <table class="table table-hover no-margins">
            <thead>
                <tr>
                    <th>Estado</th>
                    <th>Agente</th>
                    <th>Correo</th>
                    <th>Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(agente,index) in agentes" :key="index">
                    <td><small>{{agente.estado}}</small></td>
                    <td>{{agente.nombres+' '+agente.apellidos}}</td>
                    <td>{{agente.email}}</td>
                    <td><button class="btn btn-outline btn-danger  dim" type="button" v-if="!agentesPusher.includes(parseInt(agente.id))" @click="cerrarSesion(agente.id)"><i class="fa fa-sign-out"></i> Cerrar Sesion</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data: function () {
        return {}
    },
    props: {
        agenteP: {
            default: () => ({})
        },
        agentesPusher: {
            default: () => ([])
        },
        cambioEstado: {
            default: () => ({})
        }
    },
    watch: {
        agenteP(data) {
            console.log(data)
            this.consultaAgente(data)
        },
        cambioEstado(data) {
            console.log(data)
            this.cambioEstadoAgente()
        }
    },
    mounted() {
        this.consultaAgente()
    },
    methods: {
        consultaAgente(data) {
            this.$store.dispatch('agentes/consultaAgente', data)
                .then(response => {
                    //
                }).catch(error => {
                    //
                })
        },
        cambioEstadoAgente() {
            this.$store.commit('agentes/cambioEstadoAgente', this.cambioEstado)
        },
        cerrarSesion(data) {
            this.$store.dispatch('agentes/cerrarSesion', data)
                .then(response => {
                    //
                }).catch(error => {
                    //
                })
        }
    },
    computed: {
        ...mapGetters({
            agentes: 'agentes/getAgentes',
        }),
    }

}
</script>
